import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';


import { IndexComponent } from './index/index.component';
import { TextboxComponent } from './textbox/textbox.component';
import { CheckboxComponent } from './checkbox/checkbox.component';
import { ResultComponent } from './result/result.component';

const routes: Routes = [
  {path : 'browse', component : IndexComponent},
  {path : 'home', component : IndexComponent},
//  {path : 'quizlists/:sid', component : QuizlistsComponent},
//  {path : 'quiz/:sid/:qid/:hash', component : QuizComponent},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BrowseRoutingModule { }
